import { render, staticRenderFns } from "./Setup2FA.vue?vue&type=template&id=f4d9f822&"
import script from "./Setup2FA.vue?vue&type=script&lang=js&"
export * from "./Setup2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4d9f822')) {
      api.createRecord('f4d9f822', component.options)
    } else {
      api.reload('f4d9f822', component.options)
    }
    module.hot.accept("./Setup2FA.vue?vue&type=template&id=f4d9f822&", function () {
      api.rerender('f4d9f822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/Setup2FA/Setup2FA.vue"
export default component.exports